
<div class="row">
    <div class="col-12 wizard-question">
        {{'contractModifications.wizard.questions.SelectContractAndModificationType' | translate}}
    </div>
</div>
<div class="row justify-content-center my-3">
    <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
        <label class="label-input required">
            {{'contractModifications.wizard.contractLabel' | translate}}
        </label>
        <div HJSuppress *ngIf="contractsDataSource?.length === 1" class="single-contract fw-semibold mt-3 mb-4">
            {{ contractsDataSource[0].number }}
        </div>
        <div *ngIf="contractsDataSource?.length > 1" class="input-dropdown-container">
            <kendo-combobox HJSuppress
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                [size]="sizeLarge"
                name="contractId"
                placeholder="{{'contractModifications.wizard.placeholder.selectContract' | translate}}"
                [clearButton]="false"
                [data]="contractsDataSource"
                [textField]="'number'"
                [valueField]="'contractId'"
                [valuePrimitive]="true"
                [(ngModel)]="contractModificationRequest.contractId"
                (ngModelChange)="contractSelectHandler($event)"
                #selectContract
                (click)="!selectContract.isOpen ? selectContract.toggle() : null"
                [popupSettings]="{popupClass : 'data-hj-suppress'}"
            >
            </kendo-combobox>
        </div>
    </div>
</div>

<div *ngIf="contractsDataSource?.length > 0" class="row justify-content-center my-3">
    <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
        <label class="label-input required">
            {{'contractModifications.wizard.modificationTypeLabel' | translate}}
        </label>
        <div class="input-dropdown-container">
            <kendo-combobox HJSuppress
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                [size]="sizeLarge"
                name="modificationType"
                placeholder="{{'contractModifications.wizard.placeholder.selectModificationType' | translate}}"
                [clearButton]="false"
                [data]="contractModificationRequestType"
                [textField]="'value'"
                [valueField]="'id'"
                [valuePrimitive]="true"
                [(ngModel)]="contractModificationRequest.dictionaryModificationTypeId"
                (ngModelChange)="contractModificationRequestTypeChangeHandler($event)"
                #contractModificationTypeControl
                [disabled]="modificationTypeDisabled"
                (click)="!contractModificationTypeControl.isOpen && !contractModificationTypeControl.disabled ?
                contractModificationTypeControl.toggle() : null"
                [popupSettings]="{popupClass : 'data-hj-suppress'}"
            >
            </kendo-combobox>
        </div>
    </div>
</div>

<div class="row justify-content-center my-3"
    *ngIf="contractModificationRequest.dictionaryModificationTypeId && contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.REIMBURSEMENT?.id">
    <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
        <label class="label-input required">
            {{'contractModifications.wizard.reimbursementType' | translate}}
        </label>
        <div class="input-dropdown-container">
            <kendo-combobox HJSuppress
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                [size]="sizeLarge"
                name="reimbursementType"
                placeholder="{{'contractModifications.wizard.placeholder.selectReimbursementType' | translate}}"
                [clearButton]="false"
                [data]="reimbursementTypeDatasource"
                [textField]="'value'"
                [valueField]="'id'"
                [valuePrimitive]="true"
                [(ngModel)]="contractModificationRequest.dictionaryReimbursementTypeId"
                (ngModelChange)="contractModificationReimbursementTypeChangeHandler($event)"
                #reimbursementTypeControl
                (click)="!reimbursementTypeControl.isOpen ? reimbursementTypeControl.toggle() : null"
                [popupSettings]="{popupClass : 'data-hj-suppress'}"
            >
            </kendo-combobox>
        </div>
    </div>
</div>

<ng-container
  *ngIf="[DICTIONARY_CONTRACT_MODIFICATION_TYPE.DIRECT_DEBIT?.id]
    .includes(contractModificationRequest.dictionaryModificationTypeId) && documentName"
>
    <div class="row justify-content-center my-3">
        <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4"
            [innerHTML] ="'contractModifications.wizard.placeholder.downloadForm' | translate">
        </div>
    </div>
    <div class="row justify-content-center my-3">
        <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
            <div class="d-flex justify-content-between document-item py-3">
                <div class="d-flex align-items-center">
                    <div class="document-icon">
                        <kendo-icon HJSuppres [name]="getFileTypeIcon(documentName)" class="file-icon"></kendo-icon>
                    </div>
                    <div HJSuppress class="fw-bold fs-5">{{ documentName }}</div>
                </div>

                <button class="btn m-outline-btn" (click)="downloadDocument(documentName)">
                    <i class="app-icon icon icon-download icon-xl"></i>
                </button>
            </div>
        </div>
    </div>
</ng-container>

<ng-container
  *ngIf="[DICTIONARY_CONTRACT_MODIFICATION_TYPE.OTHER?.id,
    DICTIONARY_CONTRACT_MODIFICATION_TYPE.FINANCING_OFFER?.id,
    DICTIONARY_CONTRACT_MODIFICATION_TYPE.COMPLAINTS?.id,
    DICTIONARY_CONTRACT_MODIFICATION_TYPE.CONTRACT_ASSIGNMENT?.id,
    DICTIONARY_CONTRACT_MODIFICATION_TYPE.DIRECT_DEBIT?.id]
    .includes(contractModificationRequest.dictionaryModificationTypeId)"
>
    <div *ngIf="(contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.OTHER?.id)"
        class="row justify-content-center my-3">
        <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 input-col">
            <label class="label-input required">
                {{'contractModifications.wizard.otherModificationType' | translate}}
            </label>
                <input kendoTextBox
                    name="otherModificationType"
                    type="text"
                    class="text-input"
                    placeholder="{{'contractModifications.wizard.placeholder.modificationType' | translate}}"
                    [(ngModel)]="contractModificationRequest.otherModificationType"
                    required/>
        </div>
    </div>

    <div
        *ngIf="![DICTIONARY_CONTRACT_MODIFICATION_TYPE.DIRECT_DEBIT?.id]
        .includes(contractModificationRequest.dictionaryModificationTypeId)"
        class="row justify-content-center my-3"
    >
        <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
            <label class="label-input required">
                {{'contractModifications.wizard.description' | translate}}
            </label>
            <kendo-textarea
                name="modificationDescription"
                rounded="large"
                class="custom-kendo-control-xl"
                resizable="none"
                placeholder="{{ ((contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.CONTRACT_ASSIGNMENT?.id)
                    ? 'contractModifications.wizard.placeholder.contractAssignmentDescription'
                    : 'contractModifications.wizard.placeholder.description') | translate }}"
                [(ngModel)]="contractModificationRequest.description"
                [rows]="3"
                required>
            </kendo-textarea>
        </div>
    </div>

    <div class="row justify-content-center my-3 l-uploader-container">
        <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
            <contract-modification-uploader
                [contractModificationRequest]="contractModificationRequest"

                [deleteFileHandler]="deleteFileHandler"
                [uploadFilesHandler]="uploadFilesHandler"
            >
            </contract-modification-uploader>
        </div>
    </div>

    <div
        *ngIf="contractModificationRequest.dictionaryModificationTypeId !==
        DICTIONARY_CONTRACT_MODIFICATION_TYPE.DIRECT_DEBIT?.id"
        class="row justify-content-center my-3 l-spacer-top"
    >
        <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 required-fields-label"
            [innerHTML] ="'common.requiredFields' | translate">
        </div>
    </div>

    <div
        *ngIf="contractModificationRequest.dictionaryModificationTypeId ===
        DICTIONARY_CONTRACT_MODIFICATION_TYPE.DIRECT_DEBIT?.id"
        class="row justify-content-center my-3 l-spacer-top"
    >
        <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4"
            [innerHTML] ="'contractModifications.wizard.placeholder.attachDirectDebitMandate' | translate">
        </div>
    </div>
</ng-container>

<div class="row justify-content-center my-3 l-next-step-container">
    <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 action">
        <div class="d-flex justify-content-center my-3 mt-5">
            <button
                class="btn primary-btn l-btn-alignment"
                [disabled]="(!contractModificationRequest.dictionaryModificationTypeId) ||
                    (contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.REIMBURSEMENT?.id
                        && !contractModificationRequest.dictionaryReimbursementTypeId)
                    ||
                    (contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.DIRECT_DEBIT?.id
                        && contractModificationRequest?.contractModificationRequestXDocuments?.length === 0) ||
                    ([DICTIONARY_CONTRACT_MODIFICATION_TYPE.OTHER?.id,
                    DICTIONARY_CONTRACT_MODIFICATION_TYPE.FINANCING_OFFER?.id,
                    DICTIONARY_CONTRACT_MODIFICATION_TYPE.COMPLAINTS?.id,
                    DICTIONARY_CONTRACT_MODIFICATION_TYPE.CONTRACT_ASSIGNMENT?.id]
                    .includes(contractModificationRequest.dictionaryModificationTypeId)
                        && (!contractModificationRequest.otherModificationType || !contractModificationRequest.description))"
                (click)="nextStepHandler(wizardStepsEnum.ContractModification_ChooseContractAndModificationType)"
            >
                {{'contractModifications.wizard.continueBtn' | translate}}
            </button>
        </div>
    </div>
</div>
